/* ============================================================================
   data/districts.js - GENERATED FILE, do not edit by hand.
   Regenerate with:  node scripts/build-districts.js
   (the STATES table is maintained inside that script)

   Generated:  2026-09-08
   Source:     https://de.wikipedia.org/wiki/Liste_der_Kfz-Kennzeichen_in_Deutschland
   List state: 1. Dezember 2023
   Entries:    726

   Unterscheidungszeichen are retired and reissued, so this list ages.
   It is used for a soft check only: an unknown code produces a warning,
   never an error, and never blocks an order.

   Federal codes without a federal state (X = NATO, Y = Bundeswehr and the
   numeric diplomatic plates) are not included.
   ========================================================================= */
var PlateDistricts = (function () {
  'use strict';

  /* Federal states. flagColors are plain horizontal colour bars, top to
     bottom - no coats of arms, no image files. */
  var STATES = {
    BW: { id: "BW", name: "Baden-Württemberg",
         flagColors: ['#000000', '#FFCE00'],
         iconUrl: "seal-bw.webp" },
    BY: { id: "BY", name: "Bayern",
         flagColors: ['#FFFFFF', '#0098D8'],
         iconUrl: "seal-by.webp" },
    BE: { id: "BE", name: "Berlin",
         flagColors: ['#E4000F', '#FFFFFF', '#E4000F'],
         iconUrl: "" },
    BB: { id: "BB", name: "Brandenburg",
         flagColors: ['#E4000F', '#FFFFFF'],
         iconUrl: "seal-bb.webp" },
    HB: { id: "HB", name: "Bremen",
         flagColors: ['#C3161C', '#FFFFFF', '#C3161C', '#FFFFFF'],
         iconUrl: "seal-hb.webp" },
    HH: { id: "HH", name: "Hamburg",
         flagColors: ['#DA121A', '#FFFFFF'],
         iconUrl: "seal-hh.webp" },
    HE: { id: "HE", name: "Hessen",
         flagColors: ['#E4000F', '#FFFFFF'],
         iconUrl: "seal-he.webp" },
    MV: { id: "MV", name: "Mecklenburg-Vorpommern",
         flagColors: ['#0066B3', '#FFFFFF', '#FFD400', '#FFFFFF', '#E4000F'],
         iconUrl: "seal-mv.webp" },
    NI: { id: "NI", name: "Niedersachsen",
         flagColors: ['#000000', '#E4000F', '#FFCE00'],
         iconUrl: "seal-ni.webp" },
    NW: { id: "NW", name: "Nordrhein-Westfalen",
         flagColors: ['#009B48', '#FFFFFF', '#E4000F'],
         iconUrl: "seal-nw.webp" },
    RP: { id: "RP", name: "Rheinland-Pfalz",
         flagColors: ['#000000', '#E4000F', '#FFCE00'],
         iconUrl: "seal-rp.webp" },
    SL: { id: "SL", name: "Saarland",
         flagColors: ['#000000', '#E4000F', '#FFCE00'],
         iconUrl: "seal-sl.webp" },
    SN: { id: "SN", name: "Sachsen",
         flagColors: ['#FFFFFF', '#009B48'],
         iconUrl: "seal-sn.webp" },
    ST: { id: "ST", name: "Sachsen-Anhalt",
         flagColors: ['#FFCE00', '#000000'],
         iconUrl: "seal-st.webp" },
    SH: { id: "SH", name: "Schleswig-Holstein",
         flagColors: ['#0066B3', '#FFFFFF', '#E4000F'],
         iconUrl: "seal-sh.webp" },
    TH: { id: "TH", name: "Thüringen",
         flagColors: ['#FFFFFF', '#E4000F'],
         iconUrl: "seal-th.webp" }
  };

  var DISTRICTS = {
    "A": { district: "Augsburg", state: "BY" },
    "AA": { district: "Ostalbkreis", state: "BW" },
    "AB": { district: "Aschaffenburg", state: "BY" },
    "ABG": { district: "Landkreis Altenburger Land", state: "TH" },
    "ABI": { district: "Landkreis Anhalt-Bitterfeld", state: "ST" },
    "AC": { district: "Städteregion Aachen", state: "NW" },
    "AE": { district: "Vogtlandkreis", state: "SN" },
    "AH": { district: "Kreis Borken", state: "NW" },
    "AIB": { district: "Landkreis München", state: "BY" },
    "AIC": { district: "Landkreis Aichach-Friedberg", state: "BY" },
    "AK": { district: "Landkreis Altenkirchen (Westerwald)", state: "RP" },
    "ALF": { district: "Landkreis Hildesheim", state: "NI" },
    "ALZ": { district: "Landkreis Aschaffenburg", state: "BY" },
    "AM": { district: "Amberg", state: "BY" },
    "AN": { district: "Ansbach", state: "BY" },
    "ANA": { district: "Erzgebirgskreis", state: "SN" },
    "ANG": { district: "Landkreis Uckermark", state: "BB" },
    "ANK": { district: "Landkreis Vorpommern-Greifswald ohne die Stadt Greifswald", state: "MV" },
    "AP": { district: "Landkreis Weimarer Land", state: "TH" },
    "APD": { district: "Landkreis Weimarer Land", state: "TH" },
    "ARN": { district: "Ilm-Kreis", state: "TH" },
    "ART": { district: "Kyffhäuserkreis", state: "TH" },
    "AS": { district: "Landkreis Amberg-Sulzbach", state: "BY" },
    "ASL": { district: "Salzlandkreis", state: "ST" },
    "ASZ": { district: "Erzgebirgskreis", state: "SN" },
    "AT": { district: "Landkreis Vorpommern-Greifswald ohne die Stadt Greifswald", state: "MV" },
    "AU": { district: "Erzgebirgskreis", state: "SN" },
    "AUR": { district: "Landkreis Aurich", state: "NI" },
    "AW": { district: "Landkreis Ahrweiler", state: "RP" },
    "AZ": { district: "Landkreis Alzey-Worms", state: "RP" },
    "AZE": { district: "Landkreis Anhalt-Bitterfeld", state: "ST" },
    "AÖ": { district: "Landkreis Altötting", state: "BY" },
    "B": { district: "Berlin", state: "BE" },
    "BA": { district: "Bamberg", state: "BY" },
    "BAD": { district: "Baden-Baden", state: "BW" },
    "BAR": { district: "Landkreis Barnim", state: "BB" },
    "BB": { district: "Landkreis Böblingen", state: "BW" },
    "BBG": { district: "Salzlandkreis", state: "ST" },
    "BBL": { district: "Brandenburg", state: "BB" },
    "BC": { district: "Landkreis Biberach", state: "BW" },
    "BCH": { district: "Neckar-Odenwald-Kreis", state: "BW" },
    "BE": { district: "Kreis Warendorf", state: "NW" },
    "BED": { district: "Landkreis Mittelsachsen", state: "SN" },
    "BEL": { district: "Landkreis Potsdam-Mittelmark", state: "BB" },
    "BER": { district: "Landkreis Barnim", state: "BB" },
    "BF": { district: "Kreis Steinfurt", state: "NW" },
    "BGD": { district: "Landkreis Berchtesgadener Land", state: "BY" },
    "BGL": { district: "Landkreis Berchtesgadener Land", state: "BY" },
    "BH": { district: "Ortenaukreis", state: "BW" },
    "BI": { district: "Bielefeld", state: "NW" },
    "BID": { district: "Landkreis Marburg-Biedenkopf", state: "HE" },
    "BIN": { district: "Landkreis Mainz-Bingen", state: "RP" },
    "BIR": { district: "Landkreis Birkenfeld", state: "RP" },
    "BIT": { district: "Eifelkreis Bitburg-Prüm", state: "RP" },
    "BIW": { district: "Landkreis Bautzen", state: "SN" },
    "BK": { district: "Rems-Murr-Kreis", state: "BW" },
    "BKS": { district: "Landkreis Bernkastel-Wittlich", state: "RP" },
    "BL": { district: "Zollernalbkreis", state: "BW" },
    "BLB": { district: "Kreis Siegen-Wittgenstein", state: "NW" },
    "BLK": { district: "Burgenlandkreis", state: "ST" },
    "BM": { district: "Rhein-Erft-Kreis", state: "NW" },
    "BN": { district: "Bonn", state: "NW" },
    "BNA": { district: "Landkreis Leipzig", state: "SN" },
    "BO": { district: "Bochum", state: "NW" },
    "BOG": { district: "Landkreis Straubing-Bogen", state: "BY" },
    "BOH": { district: "Kreis Borken", state: "NW" },
    "BOR": { district: "Kreis Borken", state: "NW" },
    "BOT": { district: "Bottrop", state: "NW" },
    "BR": { district: "Landkreis Karlsruhe", state: "BW" },
    "BRA": { district: "Landkreis Wesermarsch", state: "NI" },
    "BRB": { district: "Brandenburg an der Havel", state: "BB" },
    "BRG": { district: "Landkreis Jerichower Land", state: "ST" },
    "BRK": { district: "Landkreis Bad Kissingen", state: "BY" },
    "BRL": { district: "Landkreis Goslar", state: "NI" },
    "BRV": { district: "Landkreis Rotenburg (Wümme)", state: "NI" },
    "BS": { district: "Braunschweig", state: "NI" },
    "BSB": { district: "Landkreis Osnabrück", state: "NI" },
    "BSK": { district: "Landkreis Oder-Spree", state: "BB" },
    "BT": { district: "Bayreuth", state: "BY" },
    "BTF": { district: "Landkreis Anhalt-Bitterfeld", state: "ST" },
    "BUL": { district: "Landkreis Amberg-Sulzbach", state: "BY" },
    "BWL": { district: "Baden-Württemberg", state: "BW" },
    "BYL": { district: "Bayern", state: "BY" },
    "BZ": { district: "Landkreis Bautzen", state: "SN" },
    "BÖ": { district: "Landkreis Börde", state: "ST" },
    "BÜD": { district: "Wetteraukreis", state: "HE" },
    "BÜR": { district: "Kreis Paderborn", state: "NW" },
    "BÜS": { district: "Gemeinde Büsingen am Hochrhein", state: "BW" },
    "BÜZ": { district: "Landkreis Rostock", state: "MV" },
    "C": { district: "Chemnitz", state: "SN" },
    "CA": { district: "Landkreis Oberspreewald-Lausitz", state: "BB" },
    "CAS": { district: "Kreis Recklinghausen", state: "NW" },
    "CB": { district: "Cottbus", state: "BB" },
    "CE": { district: "Landkreis Celle", state: "NI" },
    "CHA": { district: "Landkreis Cham", state: "BY" },
    "CLP": { district: "Landkreis Cloppenburg", state: "NI" },
    "CLZ": { district: "Landkreis Goslar", state: "NI" },
    "CO": { district: "Coburg und Landkreis Coburg", state: "BY" },
    "COC": { district: "Landkreis Cochem-Zell", state: "RP" },
    "COE": { district: "Kreis Coesfeld", state: "NW" },
    "CR": { district: "Landkreis Schwäbisch Hall", state: "BW" },
    "CUX": { district: "Landkreis Cuxhaven", state: "NI" },
    "CW": { district: "Landkreis Calw", state: "BW" },
    "D": { district: "Düsseldorf", state: "NW" },
    "DA": { district: "Landkreis Darmstadt-Dieburg und Stadt Darmstadt", state: "HE" },
    "DAH": { district: "Landkreis Dachau", state: "BY" },
    "DAN": { district: "Landkreis Lüchow-Dannenberg", state: "NI" },
    "DAU": { district: "Landkreis Vulkaneifel", state: "RP" },
    "DBR": { district: "Landkreis Rostock", state: "MV" },
    "DD": { district: "Dresden", state: "SN" },
    "DE": { district: "Dessau-Roßlau", state: "ST" },
    "DEG": { district: "Landkreis Deggendorf", state: "BY" },
    "DEL": { district: "Delmenhorst", state: "NI" },
    "DGF": { district: "Landkreis Dingolfing-Landau", state: "BY" },
    "DH": { district: "Landkreis Diepholz", state: "NI" },
    "DI": { district: "Landkreis Darmstadt-Dieburg", state: "HE" },
    "DIL": { district: "Lahn-Dill-Kreis", state: "HE" },
    "DIN": { district: "Kreis Wesel", state: "NW" },
    "DIZ": { district: "Rhein-Lahn-Kreis", state: "RP" },
    "DKB": { district: "Landkreis Ansbach", state: "BY" },
    "DL": { district: "Landkreis Mittelsachsen", state: "SN" },
    "DLG": { district: "Landkreis Dillingen an der Donau", state: "BY" },
    "DM": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "DN": { district: "Kreis Düren", state: "NW" },
    "DO": { district: "Dortmund", state: "NW" },
    "DON": { district: "Landkreis Donau-Ries", state: "BY" },
    "DS": { district: "Schwarzwald-Baar-Kreis", state: "BW" },
    "DT": { district: "Kreis Lippe", state: "NW" },
    "DU": { district: "Duisburg", state: "NW" },
    "DUD": { district: "Landkreis Göttingen ohne die Stadt Göttingen", state: "NI" },
    "DW": { district: "Landkreis Sächsische Schweiz-Osterzgebirge", state: "SN" },
    "DZ": { district: "Landkreis Nordsachsen", state: "SN" },
    "DÜW": { district: "Landkreis Bad Dürkheim", state: "RP" },
    "E": { district: "Essen", state: "NW" },
    "EA": { district: "Wartburgkreis", state: "TH" },
    "EB": { district: "Landkreis Nordsachsen", state: "SN" },
    "EBE": { district: "Landkreis Ebersberg", state: "BY" },
    "EBN": { district: "Landkreis Haßberge", state: "BY" },
    "EBS": { district: "Landkreis Bayreuth", state: "BY" },
    "ECK": { district: "Kreis Rendsburg-Eckernförde", state: "SH" },
    "ED": { district: "Landkreis Erding", state: "BY" },
    "EE": { district: "Landkreis Elbe-Elster", state: "BB" },
    "EF": { district: "Erfurt", state: "TH" },
    "EG": { district: "Landkreis Rottal-Inn", state: "BY" },
    "EH": { district: "Landkreis Oder-Spree", state: "BB" },
    "EI": { district: "Landkreis Eichstätt", state: "BY" },
    "EIC": { district: "Landkreis Eichsfeld", state: "TH" },
    "EIL": { district: "Landkreis Mansfeld-Südharz", state: "ST" },
    "EIN": { district: "Landkreis Northeim", state: "NI" },
    "EIS": { district: "Saale-Holzland-Kreis", state: "TH" },
    "EL": { district: "Landkreis Emsland", state: "NI" },
    "EM": { district: "Landkreis Emmendingen", state: "BW" },
    "EMD": { district: "Emden", state: "NI" },
    "EMS": { district: "Rhein-Lahn-Kreis", state: "RP" },
    "EN": { district: "Ennepe-Ruhr-Kreis", state: "NW" },
    "ER": { district: "Erlangen", state: "BY" },
    "ERB": { district: "Odenwaldkreis", state: "HE" },
    "ERH": { district: "Landkreis Erlangen-Höchstadt", state: "BY" },
    "ERK": { district: "Kreis Heinsberg", state: "NW" },
    "ERZ": { district: "Erzgebirgskreis", state: "SN" },
    "ES": { district: "Landkreis Esslingen", state: "BW" },
    "ESB": { district: "Landkreis Amberg-Sulzbach", state: "BY" },
    "ESW": { district: "Werra-Meißner-Kreis", state: "HE" },
    "EU": { district: "Kreis Euskirchen", state: "NW" },
    "EW": { district: "Landkreis Barnim", state: "BB" },
    "F": { district: "Frankfurt am Main", state: "HE" },
    "FB": { district: "Wetteraukreis", state: "HE" },
    "FD": { district: "Landkreis Fulda", state: "HE" },
    "FDB": { district: "Landkreis Aichach-Friedberg", state: "BY" },
    "FDS": { district: "Landkreis Freudenstadt", state: "BW" },
    "FEU": { district: "Landkreis Ansbach", state: "BY" },
    "FF": { district: "Frankfurt (Oder)", state: "BB" },
    "FFB": { district: "Landkreis Fürstenfeldbruck", state: "BY" },
    "FG": { district: "Landkreis Mittelsachsen", state: "SN" },
    "FI": { district: "Landkreis Elbe-Elster", state: "BB" },
    "FKB": { district: "Landkreis Waldeck-Frankenberg", state: "HE" },
    "FL": { district: "Flensburg", state: "SH" },
    "FLÖ": { district: "Landkreis Mittelsachsen", state: "SN" },
    "FN": { district: "Bodenseekreis", state: "BW" },
    "FO": { district: "Landkreis Forchheim", state: "BY" },
    "FOR": { district: "Landkreis Spree-Neiße", state: "BB" },
    "FR": { district: "Freiburg im Breisgau", state: "BW" },
    "FRG": { district: "Landkreis Freyung-Grafenau", state: "BY" },
    "FRI": { district: "Landkreis Friesland", state: "NI" },
    "FRW": { district: "Landkreis Märkisch-Oderland", state: "BB" },
    "FS": { district: "Landkreis Freising", state: "BY" },
    "FT": { district: "Frankenthal (Pfalz)", state: "RP" },
    "FTL": { district: "Landkreis Sächsische Schweiz-Osterzgebirge", state: "SN" },
    "FW": { district: "Landkreis Oder-Spree", state: "BB" },
    "FZ": { district: "Schwalm-Eder-Kreis", state: "HE" },
    "FÜ": { district: "Fürth", state: "BY" },
    "FÜS": { district: "Landkreis Ostallgäu", state: "BY" },
    "G": { district: "Gera", state: "TH" },
    "GA": { district: "Altmarkkreis Salzwedel", state: "ST" },
    "GAN": { district: "Landkreis Northeim", state: "NI" },
    "GAP": { district: "Landkreis Garmisch-Partenkirchen", state: "BY" },
    "GC": { district: "Landkreis Zwickau", state: "SN" },
    "GD": { district: "Ostalbkreis", state: "BW" },
    "GDB": { district: "Landkreis Nordwestmecklenburg ohne die Stadt Wismar", state: "MV" },
    "GE": { district: "Gelsenkirchen", state: "NW" },
    "GEL": { district: "Kreis Kleve", state: "NW" },
    "GEO": { district: "Landkreis Haßberge", state: "BY" },
    "GER": { district: "Landkreis Germersheim", state: "RP" },
    "GF": { district: "Landkreis Gifhorn", state: "NI" },
    "GG": { district: "Kreis Groß-Gerau", state: "HE" },
    "GHA": { district: "Landkreis Leipzig", state: "SN" },
    "GHC": { district: "Landkreis Wittenberg", state: "ST" },
    "GI": { district: "Landkreis Gießen", state: "HE" },
    "GK": { district: "Kreis Heinsberg", state: "NW" },
    "GL": { district: "Rheinisch-Bergischer Kreis", state: "NW" },
    "GLA": { district: "Kreis Recklinghausen", state: "NW" },
    "GM": { district: "Oberbergischer Kreis", state: "NW" },
    "GMN": { district: "Landkreis Vorpommern-Rügen ohne die Stadt Stralsund", state: "MV" },
    "GN": { district: "Main-Kinzig-Kreis", state: "HE" },
    "GNT": { district: "Landkreis Jerichower Land", state: "ST" },
    "GOA": { district: "Rhein-Hunsrück-Kreis", state: "RP" },
    "GOH": { district: "Rhein-Lahn-Kreis", state: "RP" },
    "GP": { district: "Landkreis Göppingen", state: "BW" },
    "GR": { district: "Landkreis Görlitz", state: "SN" },
    "GRA": { district: "Landkreis Freyung-Grafenau", state: "BY" },
    "GRH": { district: "Landkreis Meißen", state: "SN" },
    "GRI": { district: "Landkreis Rottal-Inn", state: "BY" },
    "GRM": { district: "Landkreis Leipzig", state: "SN" },
    "GRZ": { district: "Landkreis Greiz", state: "TH" },
    "GS": { district: "Landkreis Goslar", state: "NI" },
    "GT": { district: "Kreis Gütersloh", state: "NW" },
    "GTH": { district: "Landkreis Gotha", state: "TH" },
    "GUB": { district: "Landkreis Spree-Neiße", state: "BB" },
    "GUN": { district: "Landkreis Weißenburg-Gunzenhausen", state: "BY" },
    "GV": { district: "Rhein-Kreis Neuss", state: "NW" },
    "GVM": { district: "Landkreis Nordwestmecklenburg ohne die Stadt Wismar", state: "MV" },
    "GW": { district: "Landkreis Vorpommern-Greifswald ohne die Stadt Greifswald", state: "MV" },
    "GZ": { district: "Landkreis Günzburg", state: "BY" },
    "GÖ": { district: "Landkreis Göttingen", state: "NI" },
    "GÜ": { district: "Landkreis Rostock", state: "MV" },
    "H": { district: "Region Hannover", state: "NI" },
    "HA": { district: "Hagen", state: "NW" },
    "HAB": { district: "Landkreis Bad Kissingen", state: "BY" },
    "HAL": { district: "Halle (Saale)", state: "ST" },
    "HAM": { district: "Hamm", state: "NW" },
    "HAS": { district: "Landkreis Haßberge", state: "BY" },
    "HB": { district: "Bremen", state: "HB" },
    "HBN": { district: "Landkreis Hildburghausen", state: "TH" },
    "HBS": { district: "Landkreis Harz", state: "ST" },
    "HC": { district: "Landkreis Mittelsachsen", state: "SN" },
    "HCH": { district: "Landkreis Freudenstadt", state: "BW" },
    "HD": { district: "Heidelberg", state: "BW" },
    "HDH": { district: "Landkreis Heidenheim", state: "BW" },
    "HDL": { district: "Landkreis Börde", state: "ST" },
    "HE": { district: "Landkreis Helmstedt", state: "NI" },
    "HEB": { district: "Landkreis Nürnberger Land", state: "BY" },
    "HEF": { district: "Landkreis Hersfeld-Rotenburg", state: "HE" },
    "HEI": { district: "Kreis Dithmarschen", state: "SH" },
    "HEL": { district: "Hessen", state: "HE" },
    "HER": { district: "Herne", state: "NW" },
    "HET": { district: "Landkreis Mansfeld-Südharz", state: "ST" },
    "HF": { district: "Kreis Herford", state: "NW" },
    "HG": { district: "Hochtaunuskreis", state: "HE" },
    "HGN": { district: "Landkreis Ludwigslust-Parchim", state: "MV" },
    "HGW": { district: "Greifswald", state: "MV" },
    "HH": { district: "Hamburg", state: "HH" },
    "HHM": { district: "Burgenlandkreis", state: "ST" },
    "HI": { district: "Landkreis Hildesheim", state: "NI" },
    "HIG": { district: "Landkreis Eichsfeld", state: "TH" },
    "HIP": { district: "Landkreis Roth", state: "BY" },
    "HK": { district: "Landkreis Heidekreis", state: "NI" },
    "HL": { district: "Lübeck", state: "SH" },
    "HM": { district: "Landkreis Hameln-Pyrmont", state: "NI" },
    "HMÜ": { district: "Landkreis Göttingen ohne die Stadt Göttingen", state: "NI" },
    "HN": { district: "Heilbronn", state: "BW" },
    "HO": { district: "Hof", state: "BY" },
    "HOG": { district: "Landkreis Kassel", state: "HE" },
    "HOH": { district: "Landkreis Haßberge", state: "BY" },
    "HOL": { district: "Landkreis Holzminden", state: "NI" },
    "HOM": { district: "Saarpfalz-Kreis ohne die Stadt St. Ingbert", state: "SL" },
    "HOR": { district: "Landkreis Freudenstadt", state: "BW" },
    "HOT": { district: "Landkreis Zwickau", state: "SN" },
    "HP": { district: "Landkreis Bergstraße", state: "HE" },
    "HR": { district: "Schwalm-Eder-Kreis", state: "HE" },
    "HRO": { district: "Rostock", state: "MV" },
    "HS": { district: "Kreis Heinsberg", state: "NW" },
    "HSK": { district: "Hochsauerlandkreis", state: "NW" },
    "HST": { district: "Stralsund", state: "MV" },
    "HU": { district: "Hanau", state: "HE" },
    "HV": { district: "Landkreis Stendal", state: "ST" },
    "HVL": { district: "Landkreis Havelland", state: "BB" },
    "HWI": { district: "Wismar", state: "MV" },
    "HX": { district: "Kreis Höxter", state: "NW" },
    "HY": { district: "Landkreis Bautzen", state: "SN" },
    "HZ": { district: "Landkreis Harz", state: "ST" },
    "HÖS": { district: "Landkreis Erlangen-Höchstadt", state: "BY" },
    "IGB": { district: "St. Ingbert", state: "SL" },
    "IK": { district: "Ilm-Kreis", state: "TH" },
    "IL": { district: "Ilm-Kreis", state: "TH" },
    "ILL": { district: "Landkreis Neu-Ulm", state: "BY" },
    "IN": { district: "Ingolstadt", state: "BY" },
    "IZ": { district: "Kreis Steinburg", state: "SH" },
    "J": { district: "Jena", state: "TH" },
    "JB": { district: "Landkreis Teltow-Fläming", state: "BB" },
    "JE": { district: "Landkreis Wittenberg", state: "ST" },
    "JL": { district: "Landkreis Jerichower Land", state: "ST" },
    "JÜL": { district: "Kreis Düren", state: "NW" },
    "K": { district: "Köln", state: "NW" },
    "KA": { district: "Karlsruhe", state: "BW" },
    "KB": { district: "Landkreis Waldeck-Frankenberg", state: "HE" },
    "KC": { district: "Landkreis Kronach", state: "BY" },
    "KE": { district: "Kempten (Allgäu)", state: "BY" },
    "KEH": { district: "Landkreis Kelheim", state: "BY" },
    "KEL": { district: "Ortenaukreis", state: "BW" },
    "KEM": { district: "Landkreis Bayreuth", state: "BY" },
    "KF": { district: "Kaufbeuren", state: "BY" },
    "KG": { district: "Landkreis Bad Kissingen", state: "BY" },
    "KH": { district: "Landkreis Bad Kreuznach", state: "RP" },
    "KI": { district: "Kiel", state: "SH" },
    "KIB": { district: "Donnersbergkreis", state: "RP" },
    "KK": { district: "Kreis Viersen", state: "NW" },
    "KL": { district: "Kaiserslautern", state: "RP" },
    "KLE": { district: "Kreis Kleve", state: "NW" },
    "KLZ": { district: "Altmarkkreis Salzwedel", state: "ST" },
    "KM": { district: "Landkreis Bautzen", state: "SN" },
    "KN": { district: "Landkreis Konstanz ohne die Gemeinde Büsingen am Hochrhein", state: "BW" },
    "KO": { district: "Koblenz", state: "RP" },
    "KR": { district: "Krefeld", state: "NW" },
    "KRU": { district: "Landkreis Günzburg", state: "BY" },
    "KS": { district: "Landkreis Kassel und Stadt Kassel", state: "HE" },
    "KT": { district: "Landkreis Kitzingen", state: "BY" },
    "KU": { district: "Landkreis Kulmbach", state: "BY" },
    "KUS": { district: "Landkreis Kusel", state: "RP" },
    "KW": { district: "Landkreis Dahme-Spreewald", state: "BB" },
    "KY": { district: "Landkreis Ostprignitz-Ruppin", state: "BB" },
    "KYF": { district: "Kyffhäuserkreis", state: "TH" },
    "KÖN": { district: "Landkreis Rhön-Grabfeld", state: "BY" },
    "KÖT": { district: "Landkreis Anhalt-Bitterfeld", state: "ST" },
    "KÖZ": { district: "Landkreis Cham", state: "BY" },
    "KÜN": { district: "Hohenlohekreis", state: "BW" },
    "L": { district: "Leipzig", state: "SN" },
    "LA": { district: "Landshut", state: "BY" },
    "LAN": { district: "Landkreis Dingolfing-Landau", state: "BY" },
    "LAU": { district: "Landkreis Nürnberger Land", state: "BY" },
    "LB": { district: "Landkreis Ludwigsburg", state: "BW" },
    "LBS": { district: "Saale-Orla-Kreis", state: "TH" },
    "LBZ": { district: "Landkreis Ludwigslust-Parchim", state: "MV" },
    "LC": { district: "Landkreis Dahme-Spreewald", state: "BB" },
    "LD": { district: "Landau in der Pfalz", state: "RP" },
    "LDK": { district: "Lahn-Dill-Kreis", state: "HE" },
    "LDS": { district: "Landkreis Dahme-Spreewald", state: "BB" },
    "LE": { district: "Kreis Lippe", state: "NW" },
    "LEO": { district: "Landkreis Böblingen", state: "BW" },
    "LER": { district: "Landkreis Leer", state: "NI" },
    "LEV": { district: "Leverkusen", state: "NW" },
    "LF": { district: "Landkreis Altötting", state: "BY" },
    "LG": { district: "Landkreis Lüneburg", state: "NI" },
    "LH": { district: "Kreis Coesfeld", state: "NW" },
    "LI": { district: "Landkreis Lindau (Bodensee)", state: "BY" },
    "LIB": { district: "Landkreis Elbe-Elster", state: "BB" },
    "LIF": { district: "Landkreis Lichtenfels", state: "BY" },
    "LIP": { district: "Kreis Lippe", state: "NW" },
    "LK": { district: "Kreis Minden-Lübbecke", state: "NW" },
    "LL": { district: "Landkreis Landsberg am Lech", state: "BY" },
    "LM": { district: "Landkreis Limburg-Weilburg", state: "HE" },
    "LN": { district: "Landkreis Dahme-Spreewald", state: "BB" },
    "LOS": { district: "Landkreis Oder-Spree", state: "BB" },
    "LP": { district: "Kreis Soest", state: "NW" },
    "LR": { district: "Ortenaukreis", state: "BW" },
    "LRO": { district: "Landkreis Rostock", state: "MV" },
    "LSA": { district: "Sachsen-Anhalt", state: "ST" },
    "LSN": { district: "Sachsen", state: "SN" },
    "LSZ": { district: "Unstrut-Hainich-Kreis", state: "TH" },
    "LU": { district: "Ludwigshafen am Rhein", state: "RP" },
    "LUK": { district: "Landkreis Teltow-Fläming", state: "BB" },
    "LUP": { district: "Landkreis Ludwigslust-Parchim", state: "MV" },
    "LWL": { district: "Landkreis Ludwigslust-Parchim", state: "MV" },
    "LÖ": { district: "Landkreis Lörrach", state: "BW" },
    "LÖB": { district: "Landkreis Görlitz", state: "SN" },
    "LÜN": { district: "Kreis Unna", state: "NW" },
    "M": { district: "München", state: "BY" },
    "MA": { district: "Mannheim", state: "BW" },
    "MAB": { district: "Erzgebirgskreis", state: "SN" },
    "MAI": { district: "Landkreis Kelheim", state: "BY" },
    "MAK": { district: "Landkreis Wunsiedel im Fichtelgebirge", state: "BY" },
    "MAL": { district: "Landkreis Landshut", state: "BY" },
    "MB": { district: "Landkreis Miesbach", state: "BY" },
    "MC": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "MD": { district: "Magdeburg", state: "ST" },
    "ME": { district: "Kreis Mettmann", state: "NW" },
    "MED": { district: "Kreis Dithmarschen", state: "SH" },
    "MEG": { district: "Schwalm-Eder-Kreis", state: "HE" },
    "MEI": { district: "Landkreis Meißen", state: "SN" },
    "MEK": { district: "Erzgebirgskreis", state: "SN" },
    "MEL": { district: "Landkreis Osnabrück", state: "NI" },
    "MER": { district: "Saalekreis", state: "ST" },
    "MET": { district: "Landkreis Rhön-Grabfeld", state: "BY" },
    "MG": { district: "Mönchengladbach", state: "NW" },
    "MGH": { district: "Main-Tauber-Kreis", state: "BW" },
    "MGN": { district: "Landkreis Schmalkalden-Meiningen", state: "TH" },
    "MH": { district: "Mülheim an der Ruhr", state: "NW" },
    "MHL": { district: "Unstrut-Hainich-Kreis", state: "TH" },
    "MI": { district: "Kreis Minden-Lübbecke", state: "NW" },
    "MIL": { district: "Landkreis Miltenberg", state: "BY" },
    "MK": { district: "Märkischer Kreis", state: "NW" },
    "MKK": { district: "Main-Kinzig-Kreis", state: "HE" },
    "ML": { district: "Landkreis Mansfeld-Südharz", state: "ST" },
    "MM": { district: "Memmingen", state: "BY" },
    "MN": { district: "Landkreis Unterallgäu", state: "BY" },
    "MO": { district: "Kreis Wesel", state: "NW" },
    "MOD": { district: "Landkreis Ostallgäu", state: "BY" },
    "MOL": { district: "Landkreis Märkisch-Oderland", state: "BB" },
    "MON": { district: "Städteregion Aachen", state: "NW" },
    "MOS": { district: "Neckar-Odenwald-Kreis", state: "BW" },
    "MQ": { district: "Saalekreis", state: "ST" },
    "MR": { district: "Landkreis Marburg-Biedenkopf", state: "HE" },
    "MS": { district: "Münster", state: "NW" },
    "MSE": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "MSH": { district: "Landkreis Mansfeld-Südharz", state: "ST" },
    "MSP": { district: "Landkreis Main-Spessart", state: "BY" },
    "MST": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "MTK": { district: "Main-Taunus-Kreis", state: "HE" },
    "MTL": { district: "Landkreis Leipzig", state: "SN" },
    "MU": { district: "Landkreis München", state: "BY" },
    "MUC": { district: "München", state: "BY" },
    "MVL": { district: "Mecklenburg-Vorpommern", state: "MV" },
    "MW": { district: "Landkreis Mittelsachsen", state: "SN" },
    "MY": { district: "Landkreis Mayen-Koblenz", state: "RP" },
    "MYK": { district: "Landkreis Mayen-Koblenz", state: "RP" },
    "MZ": { district: "Mainz", state: "RP" },
    "MZG": { district: "Landkreis Merzig-Wadern", state: "SL" },
    "MÜ": { district: "Landkreis Mühldorf am Inn", state: "BY" },
    "MÜB": { district: "Landkreis Bayreuth", state: "BY" },
    "MÜL": { district: "Landkreis Breisgau-Hochschwarzwald", state: "BW" },
    "MÜR": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "N": { district: "Nürnberg", state: "BY" },
    "NAB": { district: "Landkreis Amberg-Sulzbach", state: "BY" },
    "NAI": { district: "Landkreis Hof", state: "BY" },
    "NAU": { district: "Landkreis Havelland", state: "BB" },
    "NB": { district: "Neubrandenburg", state: "MV" },
    "ND": { district: "Landkreis Neuburg-Schrobenhausen", state: "BY" },
    "NDH": { district: "Landkreis Nordhausen", state: "TH" },
    "NE": { district: "Rhein-Kreis Neuss", state: "NW" },
    "NEA": { district: "Landkreis Neustadt an der Aisch-Bad Windsheim", state: "BY" },
    "NEB": { district: "Burgenlandkreis", state: "ST" },
    "NEC": { district: "Coburg und Landkreis Coburg", state: "BY" },
    "NEN": { district: "Landkreis Schwandorf", state: "BY" },
    "NES": { district: "Landkreis Rhön-Grabfeld", state: "BY" },
    "NEU": { district: "Landkreis Breisgau-Hochschwarzwald", state: "BW" },
    "NEW": { district: "Landkreis Neustadt an der Waldnaab", state: "BY" },
    "NF": { district: "Kreis Nordfriesland", state: "SH" },
    "NH": { district: "Landkreis Sonneberg", state: "TH" },
    "NI": { district: "Landkreis Nienburg/Weser", state: "NI" },
    "NK": { district: "Landkreis Neunkirchen", state: "SL" },
    "NL": { district: "Niedersachsen", state: "NI" },
    "NM": { district: "Landkreis Neumarkt in der Oberpfalz", state: "BY" },
    "NMB": { district: "Burgenlandkreis", state: "ST" },
    "NMS": { district: "Neumünster", state: "SH" },
    "NOH": { district: "Landkreis Grafschaft Bentheim", state: "NI" },
    "NOL": { district: "Landkreis Görlitz", state: "SN" },
    "NOM": { district: "Landkreis Northeim", state: "NI" },
    "NOR": { district: "Landkreis Aurich", state: "NI" },
    "NP": { district: "Landkreis Ostprignitz-Ruppin", state: "BB" },
    "NR": { district: "Landkreis Neuwied", state: "RP" },
    "NRW": { district: "Nordrhein-Westfalen", state: "NW" },
    "NT": { district: "Landkreis Esslingen", state: "BW" },
    "NU": { district: "Landkreis Neu-Ulm", state: "BY" },
    "NVP": { district: "Landkreis Vorpommern-Rügen ohne die Stadt Stralsund", state: "MV" },
    "NW": { district: "Neustadt an der Weinstraße", state: "RP" },
    "NWM": { district: "Landkreis Nordwestmecklenburg ohne die Stadt Wismar", state: "MV" },
    "NY": { district: "Landkreis Görlitz", state: "SN" },
    "NZ": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "NÖ": { district: "Landkreis Donau-Ries", state: "BY" },
    "OA": { district: "Landkreis Oberallgäu", state: "BY" },
    "OAL": { district: "Landkreis Ostallgäu", state: "BY" },
    "OB": { district: "Oberhausen", state: "NW" },
    "OBB": { district: "Landkreis Miltenberg", state: "BY" },
    "OBG": { district: "Landkreis Stendal", state: "ST" },
    "OC": { district: "Landkreis Börde", state: "ST" },
    "OCH": { district: "Landkreis Würzburg", state: "BY" },
    "OD": { district: "Kreis Stormarn", state: "SH" },
    "OE": { district: "Kreis Olpe", state: "NW" },
    "OF": { district: "Landkreis Offenbach und Stadt Offenbach am Main", state: "HE" },
    "OG": { district: "Ortenaukreis", state: "BW" },
    "OH": { district: "Kreis Ostholstein", state: "SH" },
    "OHA": { district: "Landkreis Göttingen ohne die Stadt Göttingen", state: "NI" },
    "OHV": { district: "Landkreis Oberhavel", state: "BB" },
    "OHZ": { district: "Landkreis Osterholz", state: "NI" },
    "OK": { district: "Landkreis Börde", state: "ST" },
    "OL": { district: "Oldenburg", state: "NI" },
    "OP": { district: "Leverkusen", state: "NW" },
    "OPR": { district: "Landkreis Ostprignitz-Ruppin", state: "BB" },
    "OS": { district: "Osnabrück", state: "NI" },
    "OSL": { district: "Landkreis Oberspreewald-Lausitz", state: "BB" },
    "OTW": { district: "Landkreis Neunkirchen", state: "SL" },
    "OVI": { district: "Landkreis Schwandorf", state: "BY" },
    "OVL": { district: "Vogtlandkreis", state: "SN" },
    "OZ": { district: "Landkreis Nordsachsen", state: "SN" },
    "P": { district: "Potsdam", state: "BB" },
    "PA": { district: "Passau", state: "BY" },
    "PAF": { district: "Landkreis Pfaffenhofen an der Ilm", state: "BY" },
    "PAN": { district: "Landkreis Rottal-Inn", state: "BY" },
    "PAR": { district: "Landkreis Kelheim", state: "BY" },
    "PB": { district: "Kreis Paderborn", state: "NW" },
    "PCH": { district: "Landkreis Ludwigslust-Parchim", state: "MV" },
    "PE": { district: "Landkreis Peine", state: "NI" },
    "PEG": { district: "Landkreis Bayreuth", state: "BY" },
    "PF": { district: "Pforzheim", state: "BW" },
    "PI": { district: "Kreis Pinneberg", state: "SH" },
    "PIR": { district: "Landkreis Sächsische Schweiz-Osterzgebirge", state: "SN" },
    "PL": { district: "Vogtlandkreis", state: "SN" },
    "PLÖ": { district: "Kreis Plön", state: "SH" },
    "PM": { district: "Landkreis Potsdam-Mittelmark", state: "BB" },
    "PN": { district: "Saale-Orla-Kreis", state: "TH" },
    "PR": { district: "Landkreis Prignitz", state: "BB" },
    "PRÜ": { district: "Eifelkreis Bitburg-Prüm", state: "RP" },
    "PS": { district: "Pirmasens", state: "RP" },
    "PW": { district: "Landkreis Vorpommern-Greifswald ohne die Stadt Greifswald", state: "MV" },
    "PZ": { district: "Landkreis Uckermark", state: "BB" },
    "QFT": { district: "Saalekreis", state: "ST" },
    "QLB": { district: "Landkreis Harz", state: "ST" },
    "R": { district: "Regensburg", state: "BY" },
    "RA": { district: "Landkreis Rastatt", state: "BW" },
    "RC": { district: "Vogtlandkreis", state: "SN" },
    "RD": { district: "Kreis Rendsburg-Eckernförde", state: "SH" },
    "RDG": { district: "Landkreis Vorpommern-Rügen ohne die Stadt Stralsund", state: "MV" },
    "RE": { district: "Kreis Recklinghausen", state: "NW" },
    "REG": { district: "Landkreis Regen", state: "BY" },
    "REH": { district: "Landkreis Hof", state: "BY" },
    "REI": { district: "Landkreis Berchtesgadener Land", state: "BY" },
    "RG": { district: "Landkreis Meißen", state: "SN" },
    "RH": { district: "Landkreis Roth", state: "BY" },
    "RI": { district: "Landkreis Schaumburg", state: "NI" },
    "RID": { district: "Landkreis Kelheim", state: "BY" },
    "RIE": { district: "Landkreis Meißen", state: "SN" },
    "RL": { district: "Landkreis Mittelsachsen", state: "SN" },
    "RM": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "RN": { district: "Landkreis Havelland", state: "BB" },
    "RO": { district: "Rosenheim", state: "BY" },
    "ROD": { district: "Landkreis Cham", state: "BY" },
    "ROF": { district: "Landkreis Hersfeld-Rotenburg", state: "HE" },
    "ROK": { district: "Donnersbergkreis", state: "RP" },
    "ROL": { district: "Landkreis Kelheim", state: "BY" },
    "ROS": { district: "Landkreis Rostock", state: "MV" },
    "ROT": { district: "Landkreis Ansbach", state: "BY" },
    "ROW": { district: "Landkreis Rotenburg (Wümme)", state: "NI" },
    "RP": { district: "Rhein-Pfalz-Kreis", state: "RP" },
    "RPL": { district: "Rheinland-Pfalz", state: "RP" },
    "RS": { district: "Remscheid", state: "NW" },
    "RSL": { district: "Dessau-Roßlau", state: "ST" },
    "RT": { district: "Landkreis Reutlingen", state: "BW" },
    "RU": { district: "Landkreis Saalfeld-Rudolstadt", state: "TH" },
    "RV": { district: "Landkreis Ravensburg", state: "BW" },
    "RW": { district: "Landkreis Rottweil", state: "BW" },
    "RZ": { district: "Kreis Herzogtum Lauenburg", state: "SH" },
    "RÜD": { district: "Rheingau-Taunus-Kreis", state: "HE" },
    "RÜG": { district: "Landkreis Vorpommern-Rügen ohne die Stadt Stralsund", state: "MV" },
    "S": { district: "Stuttgart", state: "BW" },
    "SAB": { district: "Landkreis Trier-Saarburg", state: "RP" },
    "SAD": { district: "Landkreis Schwandorf", state: "BY" },
    "SAL": { district: "Saarland", state: "SL" },
    "SAN": { district: "Landkreis Hof", state: "BY" },
    "SAW": { district: "Altmarkkreis Salzwedel", state: "ST" },
    "SB": { district: "Regionalverband Saarbrücken ohne die Stadt Völklingen", state: "SL" },
    "SBG": { district: "Landkreis Vorpommern-Greifswald ohne die Stadt Greifswald", state: "MV" },
    "SBK": { district: "Salzlandkreis", state: "ST" },
    "SC": { district: "Schwabach", state: "BY" },
    "SCZ": { district: "Saale-Orla-Kreis", state: "TH" },
    "SDH": { district: "Kyffhäuserkreis", state: "TH" },
    "SDL": { district: "Landkreis Stendal", state: "ST" },
    "SDT": { district: "Landkreis Uckermark", state: "BB" },
    "SE": { district: "Kreis Segeberg", state: "SH" },
    "SEB": { district: "Landkreis Sächsische Schweiz-Osterzgebirge", state: "SN" },
    "SEE": { district: "Landkreis Märkisch-Oderland", state: "BB" },
    "SEF": { district: "Landkreis Neustadt an der Aisch-Bad Windsheim", state: "BY" },
    "SEL": { district: "Landkreis Wunsiedel im Fichtelgebirge", state: "BY" },
    "SFB": { district: "Landkreis Oberspreewald-Lausitz", state: "BB" },
    "SFT": { district: "Salzlandkreis", state: "ST" },
    "SG": { district: "Solingen", state: "NW" },
    "SGH": { district: "Landkreis Mansfeld-Südharz", state: "ST" },
    "SH": { district: "Schleswig-Holstein", state: "SH" },
    "SHA": { district: "Landkreis Schwäbisch Hall", state: "BW" },
    "SHG": { district: "Landkreis Schaumburg", state: "NI" },
    "SHK": { district: "Saale-Holzland-Kreis", state: "TH" },
    "SHL": { district: "Suhl", state: "TH" },
    "SI": { district: "Kreis Siegen-Wittgenstein", state: "NW" },
    "SIG": { district: "Landkreis Sigmaringen", state: "BW" },
    "SIM": { district: "Rhein-Hunsrück-Kreis", state: "RP" },
    "SK": { district: "Saalekreis", state: "ST" },
    "SL": { district: "Kreis Schleswig-Flensburg", state: "SH" },
    "SLE": { district: "Kreis Düren", state: "NW" },
    "SLF": { district: "Landkreis Saalfeld-Rudolstadt", state: "TH" },
    "SLG": { district: "Landkreis Ravensburg", state: "BW" },
    "SLK": { district: "Salzlandkreis", state: "ST" },
    "SLN": { district: "Landkreis Altenburger Land", state: "TH" },
    "SLS": { district: "Landkreis Saarlouis", state: "SL" },
    "SLZ": { district: "Wartburgkreis", state: "TH" },
    "SLÜ": { district: "Main-Kinzig-Kreis", state: "HE" },
    "SM": { district: "Landkreis Schmalkalden-Meiningen", state: "TH" },
    "SMÜ": { district: "Landkreis Augsburg", state: "BY" },
    "SN": { district: "Schwerin", state: "MV" },
    "SO": { district: "Kreis Soest", state: "NW" },
    "SOB": { district: "Landkreis Neuburg-Schrobenhausen", state: "BY" },
    "SOG": { district: "Landkreis Weilheim-Schongau", state: "BY" },
    "SOK": { district: "Saale-Orla-Kreis", state: "TH" },
    "SON": { district: "Landkreis Sonneberg", state: "TH" },
    "SP": { district: "Speyer", state: "RP" },
    "SPB": { district: "Landkreis Spree-Neiße", state: "BB" },
    "SPN": { district: "Landkreis Spree-Neiße", state: "BB" },
    "SR": { district: "Landkreis Straubing-Bogen", state: "BY" },
    "SRB": { district: "Landkreis Märkisch-Oderland", state: "BB" },
    "SRO": { district: "Saale-Holzland-Kreis", state: "TH" },
    "ST": { district: "Kreis Steinfurt", state: "NW" },
    "STA": { district: "Landkreis Starnberg", state: "BY" },
    "STB": { district: "Landkreis Ludwigslust-Parchim", state: "MV" },
    "STD": { district: "Landkreis Stade", state: "NI" },
    "STE": { district: "Landkreis Lichtenfels", state: "BY" },
    "STL": { district: "Erzgebirgskreis", state: "SN" },
    "STO": { district: "Landkreis Konstanz", state: "BW" },
    "SU": { district: "Rhein-Sieg-Kreis", state: "NW" },
    "SUL": { district: "Landkreis Amberg-Sulzbach", state: "BY" },
    "SW": { district: "Schweinfurt", state: "BY" },
    "SWA": { district: "Rheingau-Taunus-Kreis", state: "HE" },
    "SY": { district: "Landkreis Diepholz", state: "NI" },
    "SZ": { district: "Salzgitter", state: "NI" },
    "SZB": { district: "Erzgebirgskreis", state: "SN" },
    "SÄK": { district: "Landkreis Waldshut", state: "BW" },
    "SÖM": { district: "Landkreis Sömmerda", state: "TH" },
    "SÜW": { district: "Landkreis Südliche Weinstraße", state: "RP" },
    "TBB": { district: "Main-Tauber-Kreis", state: "BW" },
    "TDO": { district: "Landkreis Nordsachsen", state: "SN" },
    "TE": { district: "Kreis Steinfurt", state: "NW" },
    "TET": { district: "Landkreis Rostock", state: "MV" },
    "TF": { district: "Landkreis Teltow-Fläming", state: "BB" },
    "TG": { district: "Landkreis Nordsachsen", state: "SN" },
    "THL": { district: "Thüringen", state: "TH" },
    "TIR": { district: "Landkreis Tirschenreuth", state: "BY" },
    "TO": { district: "Landkreis Nordsachsen", state: "SN" },
    "TP": { district: "Landkreis Uckermark", state: "BB" },
    "TR": { district: "Landkreis Trier-Saarburg und Stadt Trier", state: "RP" },
    "TS": { district: "Landkreis Traunstein", state: "BY" },
    "TT": { district: "Bodenseekreis", state: "BW" },
    "TUT": { district: "Landkreis Tuttlingen", state: "BW" },
    "TÖL": { district: "Landkreis Bad Tölz-Wolfratshausen", state: "BY" },
    "TÜ": { district: "Landkreis Tübingen", state: "BW" },
    "UE": { district: "Landkreis Uelzen", state: "NI" },
    "UEM": { district: "Landkreis Vorpommern-Greifswald ohne die Stadt Greifswald", state: "MV" },
    "UFF": { district: "Landkreis Neustadt an der Aisch-Bad Windsheim", state: "BY" },
    "UH": { district: "Unstrut-Hainich-Kreis", state: "TH" },
    "UL": { district: "Ulm", state: "BW" },
    "UM": { district: "Landkreis Uckermark", state: "BB" },
    "UN": { district: "Kreis Unna", state: "NW" },
    "USI": { district: "Hochtaunuskreis", state: "HE" },
    "V": { district: "Vogtlandkreis", state: "SN" },
    "VAI": { district: "Landkreis Ludwigsburg", state: "BW" },
    "VB": { district: "Vogelsbergkreis", state: "HE" },
    "VEC": { district: "Landkreis Vechta", state: "NI" },
    "VER": { district: "Landkreis Verden", state: "NI" },
    "VG": { district: "Landkreis Vorpommern-Greifswald", state: "MV" },
    "VIB": { district: "Landkreis Landshut", state: "BY" },
    "VIE": { district: "Kreis Viersen", state: "NW" },
    "VIT": { district: "Landkreis Regen", state: "BY" },
    "VK": { district: "Völklingen", state: "SL" },
    "VOH": { district: "Landkreis Neustadt an der Waldnaab", state: "BY" },
    "VR": { district: "Landkreis Vorpommern-Rügen ohne die Stadt Stralsund", state: "MV" },
    "VS": { district: "Schwarzwald-Baar-Kreis", state: "BW" },
    "W": { district: "Wuppertal", state: "NW" },
    "WA": { district: "Landkreis Waldeck-Frankenberg", state: "HE" },
    "WAF": { district: "Kreis Warendorf", state: "NW" },
    "WAK": { district: "Wartburgkreis", state: "TH" },
    "WAN": { district: "Herne", state: "NW" },
    "WAR": { district: "Kreis Höxter", state: "NW" },
    "WAT": { district: "Bochum", state: "NW" },
    "WB": { district: "Landkreis Wittenberg", state: "ST" },
    "WBS": { district: "Landkreis Eichsfeld", state: "TH" },
    "WDA": { district: "Landkreis Zwickau", state: "SN" },
    "WE": { district: "Weimar", state: "TH" },
    "WEL": { district: "Landkreis Limburg-Weilburg", state: "HE" },
    "WEN": { district: "Weiden in der Oberpfalz", state: "BY" },
    "WER": { district: "Landkreis Augsburg", state: "BY" },
    "WES": { district: "Kreis Wesel", state: "NW" },
    "WF": { district: "Landkreis Wolfenbüttel", state: "NI" },
    "WG": { district: "Landkreis Ravensburg", state: "BW" },
    "WHV": { district: "Wilhelmshaven", state: "NI" },
    "WI": { district: "Wiesbaden", state: "HE" },
    "WIL": { district: "Landkreis Bernkastel-Wittlich", state: "RP" },
    "WIS": { district: "Landkreis Nordwestmecklenburg ohne die Stadt Wismar", state: "MV" },
    "WIT": { district: "Ennepe-Ruhr-Kreis", state: "NW" },
    "WIZ": { district: "Werra-Meißner-Kreis", state: "HE" },
    "WK": { district: "Landkreis Ostprignitz-Ruppin", state: "BB" },
    "WL": { district: "Landkreis Harburg", state: "NI" },
    "WLG": { district: "Landkreis Vorpommern-Greifswald ohne die Stadt Greifswald", state: "MV" },
    "WM": { district: "Landkreis Weilheim-Schongau", state: "BY" },
    "WMS": { district: "Landkreis Börde", state: "ST" },
    "WN": { district: "Rems-Murr-Kreis", state: "BW" },
    "WND": { district: "Landkreis St. Wendel", state: "SL" },
    "WO": { district: "Worms", state: "RP" },
    "WOB": { district: "Wolfsburg", state: "NI" },
    "WOH": { district: "Landkreis Kassel", state: "HE" },
    "WOL": { district: "Landkreis Freudenstadt", state: "BW" },
    "WOR": { district: "Landkreis Bad Tölz-Wolfratshausen", state: "BY" },
    "WOS": { district: "Landkreis Freyung-Grafenau", state: "BY" },
    "WR": { district: "Landkreis Harz", state: "ST" },
    "WRN": { district: "Landkreis Mecklenburgische Seenplatte ohne die Stadt Neubrandenburg", state: "MV" },
    "WS": { district: "Landkreis Mühldorf a.Inn", state: "BY" },
    "WSF": { district: "Burgenlandkreis", state: "ST" },
    "WST": { district: "Landkreis Ammerland", state: "NI" },
    "WSW": { district: "Landkreis Görlitz", state: "SN" },
    "WT": { district: "Landkreis Waldshut", state: "BW" },
    "WTL": { district: "Landkreis Osnabrück", state: "NI" },
    "WTM": { district: "Landkreis Wittmund", state: "NI" },
    "WUG": { district: "Landkreis Weißenburg-Gunzenhausen", state: "BY" },
    "WUN": { district: "Landkreis Wunsiedel im Fichtelgebirge", state: "BY" },
    "WUR": { district: "Landkreis Leipzig", state: "SN" },
    "WW": { district: "Westerwaldkreis", state: "RP" },
    "WZ": { district: "Lahn-Dill-Kreis", state: "HE" },
    "WZL": { district: "Landkreis Börde", state: "ST" },
    "WÜ": { district: "Würzburg", state: "BY" },
    "WÜM": { district: "Landkreis Cham", state: "BY" },
    "Z": { district: "Landkreis Zwickau", state: "SN" },
    "ZE": { district: "Landkreis Anhalt-Bitterfeld", state: "ST" },
    "ZEL": { district: "Landkreis Cochem-Zell", state: "RP" },
    "ZI": { district: "Landkreis Görlitz", state: "SN" },
    "ZIG": { district: "Schwalm-Eder-Kreis", state: "HE" },
    "ZP": { district: "Erzgebirgskreis", state: "SN" },
    "ZR": { district: "Landkreis Greiz", state: "TH" },
    "ZS": { district: "Landkreis Teltow-Fläming", state: "BB" },
    "ZW": { district: "Zweibrücken", state: "RP" },
    "ZZ": { district: "Burgenlandkreis", state: "ST" },
    "ÖHR": { district: "Hohenlohekreis", state: "BW" },
    "ÜB": { district: "Bodenseekreis", state: "BW" }
  };

  return { STATES: STATES, DISTRICTS: DISTRICTS };
})();
